<script lang="ts">
  import { push } from 'svelte-spa-router';
  import { currentUser, authReady } from '$lib/stores/auth';
  import AdminNav from '../components/AdminNav.svelte';
  $: if ($authReady && (!$currentUser || $currentUser.role !== 'admin')) push('/map');
</script>

<main class="admin-retro">
  <AdminNav active="retrospective" />
  <p class="open"><a href="/api/admin/retrospective" target="_blank" rel="noopener">Open in a new tab</a></p>
  {#if $currentUser?.role === 'admin'}
    <iframe src="/api/admin/retrospective" title="Campaign retrospective"></iframe>
  {/if}
</main>

<style>
  .admin-retro { max-width: 1200px; margin: 0 auto; padding: var(--s-6) var(--s-4); }
  .open { margin: 0 0 var(--s-3); font-family: var(--font-body); font-size: 0.85rem; }
  iframe { width: 100%; height: calc(100vh - 160px); border: 1px solid var(--rule); background: #fff; }
</style>
